import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

const useCleanPath = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const cleanedPath = location.pathname.replace(/\/+/g, "/")
    if (location.pathname !== cleanedPath) {
      navigate(cleanedPath, { replace: true })
    }
  }, [location.pathname, navigate])

  return null
}

export default useCleanPath
